module.exports = __webpack_public_path__ + "static/media/fully_verified.e67301db.svg";